import { render, staticRenderFns } from "./communityActivityList.vue?vue&type=template&id=b63a0b04&"
import script from "./communityActivityList.vue?vue&type=script&lang=js&"
export * from "./communityActivityList.vue?vue&type=script&lang=js&"
import style0 from "./communityActivityList.vue?vue&type=style&index=0&id=b63a0b04&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports